"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fileImageApi = void 0;
var fileImageApi = exports.fileImageApi = function fileImageApi() {
  return Promise.resolve("");
};